import { AnyMerchant, MerchantStatusResponse } from 'APIs/merchants/merchants.types';
import { createContext, useContext } from 'react';

export const CreateMerchantContext = createContext<
  | {
      merchantId: string;
      merchant: AnyMerchant | null;
      merchantStatus: MerchantStatusResponse | null;
      setMerchant: (merchant: AnyMerchant) => void;
      setMerchantStatus: (status: MerchantStatusResponse) => void;
      fetchMerchant: () => Promise<void>;
    }
  | undefined
>(undefined);

export function useCreateMerchantContext() {
  const context = useContext(CreateMerchantContext);
  if (context === undefined) {
    throw new Error('useCreateMerchantContext must be used with a CreateMerchantContext');
  }

  return context;
}
